

















































import { Component, Vue } from 'vue-property-decorator';
import { setLastUser, getLastUser } from '../../utils/storage';

@Component({
  name: 'Login',
})
export default class extends Vue {
  private showPassword = false;

  private saveLoginSession = true;

  private username = '';

  private password = '';

  private loading = false;

  created() {
    this.username = this.lastUser;
  }

  private handleLogin() {
    this.loading = true;
    this.$store
      .dispatch('user/login', { username: this.username, password: this.password })
      .then(() => {
        if (this.saveLoginSession) {
          setLastUser(this.username);
        }
        this.$router.push({ path: '/home' });
      })
      .catch(() => {
        this.loading = false;
      });
  }

  get lastUser() {
    const username = getLastUser();
    if (username) return username;
    return '';
  }
}
